module.exports = __webpack_public_path__ + "img/img-2.7a6ccfb2.jpg";